<!--
    课程分享-课时编辑
    作用：展示课程课时详情
    功能：展示/编辑/新增课时，条件筛选数据，新增/修改课时分类
    说明：版本3.0
-->
<template>
  <div
    v-loading="loading"
    class="edit-wrapper">
    <div class="text"><span class="label">课程名称：</span>{{ detail.name }}</div>
    <div class="text"><span class="label">课程简介：</span>{{ detail.introduction }}</div>
    <div class="text"><span class="label">课时数：</span>{{ detail.detail_count }}</div>
    <type-select
      :tree-data="categoryTree"
      :sel-class="selClass"
      @closeMove="closeMove"
      @refresh="handlerRefresh"
      @changeVal="handlerCascader"/>
    <el-scrollbar
      style="flex:1"
      wrap-style="overflow-x:hidden;">
      <class-hours
        ref="classHourse"
        :list="hoursList"
        @refresh="handlerRefresh"
        @change="handlerChange"
        @closeLoading="loading = false"
        @openLoading="loading = true"
        @move="handlerMove"/>
    </el-scrollbar>
  </div>
</template>
<script>
import { fetchPacketDetail, fetchPacketHours } from '@/api/courseOn';
import typeSelect from './components/typeSelect';
import classHours from './components/classHours';

export default {
  name: 'EditClassHours',
  components: {
    typeSelect,
    classHours,
  },
  data() {
    return {
      loading: false,
      categoryTree: [],
      hoursList: [],
      detail: {},
      selClass: [],
      isCloseMove: false,
      selType: null,
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    handlerRefresh() {
      this.closeMove();
      this.getDetail(() => {
        this.handlerCascader(this.selType);
      });
    },
    closeMove() {
      this.selClass = [];
      this.$refs.classHourse.closeCheck();
    },
    // 选中中变化
    handlerChange(val) {
      const newArr = this.selClass;
      newArr.forEach((item, index) => {
        if (item === val.id) {
          newArr.splice(index, 1);
        }
      });
      if (val.state) {
        newArr.push(val.id);
      }
      this.selClass = newArr;
      console.log('选中', this.selClass);
    },
    // 获取课程详情
    async getDetail(callback) {
      this.loading = true;
      const id = +this.$route.query.packetId;
      const detail = await fetchPacketDetail(id, this.$store.state.choicesSchool.id);
      const hours = await fetchPacketHours(id, this.$store.state.choicesSchool.id);
      this.loading = false;
      this.detail = detail.data;
      this.categoryTree = detail.data.detail_category_tree;
      this.hoursList = hours.items;
      if (hours.items) {
        sessionStorage.setItem('classHours', JSON.stringify(hours.items));
      } else {
        sessionStorage.setItem('classHours', JSON.stringify([]));
      }
      callback && callback();
    },
    // 搜索
    handlerCascader(val) {
      const classHours = JSON.parse(sessionStorage.getItem('classHours'));
      const newArr = [];
      classHours.forEach((item) => {
        if (item.detail_category_id === val) {
          newArr.push(item);
        }
      });
      this.hoursList = !val ? classHours : newArr;
      this.selType = val;
    },
    handlerMove(val) {
      console.log('移动', val);
    },
  },
};
</script>
<style lang="scss" scoped>
.edit-wrapper{
    padding: 30px;
    flex: none;
    height: 100vh;
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    .text{
        line-height: 30px;
        font-size: 14px;
        color: #333;
        .label{
            width: 70px;
            display: inline-block;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/editClassHours/index.vue